import React, {Component} from 'react';
import {withFirebase} from "../firebase";
import {withModal} from "../modal";
import {frameRequestService, langService} from "../services/lang.service";

// TODO: needed nav switch loader

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: this.props.list,
      loading: this.props.loading,
      language: '',
      frameRender: false
    };

    this.frameRender = this.frameRender.bind(this);
    this.renderLanguage = this.renderLanguage.bind(this);
    this.simpleButton = this.simpleButton.bind(this);
  }

  componentDidMount() {
    this.langSubscribe = langService.getLang().subscribe(lang => {
      this.setState({
        language: lang.lang
      });
    });

    this.frameSubscribe = frameRequestService.getFrame().subscribe(req => {
      this.setState({
        frameRender: req.frame
      })
    });
  }

  componentWillUnmount() {
    this.langSubscribe.unsubscribe();
    this.frameSubscribe.unsubscribe();
  }

  renderSwitch = (data) => {
    switch (data) {
      case 'ka':
        return 'No data to show';
      case 'en':
        return 'No data to show';
      case 'ru':
        return 'No data to show';
      default:
        return 'No data to show';
    }
  };

  loadData() {
    // console.log('Starting Loading');
    const promotions = this.props.firebase.db.ref('/promotions');

    promotions.on('value', snapshot => {
      // console.log('End Loading');

      const obj = snapshot.val();
      const toArrayList = Object.keys(obj).map(i => {
        return obj[i];
      });

      this.setState({
        list: toArrayList
      });

    });

  }

  frameRender(src) {
    return (
      <div>
        <iframe
          title={'modal'}
          width="560"
          height="315"
          src={'https://www.youtube.com/embed/' + src}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen>
        </iframe>
      </div>
    )
  };

  simpleButton() {
  }


  openModal(name, url) {
    this.props.modal.openModal(
      {
        name: name,
        modal: this.frameRender(url)
      }
    );
  }

  renderLanguage(obj) {
    const {language} = this.state;

    if (language.toLowerCase() === 'ka') {
      obj.name = obj.name_ka;
    } else if (language.toLowerCase() === 'en') {
      obj.name = obj.name_en;
    } else {
      obj.name = obj.name_ru;
    }
    return obj.name;
  }

  renderType = (type) => {
    return <div className={'type-badge ' + 'color--' + (type.toLowerCase())}>
      <div className="text">{type}</div>
    </div>

  };

  render() {
    const {list, loading} = this.props;
    const {language, frameRender} = this.state;

    return (
      <div className={'content-area'}>
        <div className="custom-container">
          <div className={'box-list row ' + (!list.length ? 'box-list--loading' : '') + (frameRender ? '-frame' : '')}>
            {loading
              ? frameRender
                ? null
                : [1, 2, 3, 4, 5, 6, 7, 8].map((obj, key) => {
                  return <div className="c-col col-xs-3 col-md-3 col-sm-6" key={key}>
                    <div className="item-box item-box--loading">
                      <div className="item-spinner"></div>
                    </div>
                  </div>
                })
              : list.length
                ? list.map((obj, key) => {
                  return <div className={"c-col col-xs-3 col-md-3 col-sm-6 " + (frameRender ? '-frame' : '')}
                              key={key}>
                    {obj['link_' + language]
                      ? <a href={(obj['link_' + language] ? obj['link_' + language] : '')} target={'_blank'}
                           className="item-box">
                        <div className="item-image">
                          <img src={obj['image_' + language]} alt={this.renderLanguage(obj)}/>
                          {this.renderType(obj.type)}
                        </div>
                        <div className="item-title">
                          {this.renderLanguage(obj)}
                        </div>
                      </a>
                      : <div onClick={() => this.openModal(this.renderLanguage(obj), obj.modal)} className="item-box">
                        <div className="item-image">
                          <img
                            src={obj['image_' + language]} alt={this.renderLanguage(obj)}/></div>
                        <div className="item-title">{this.renderLanguage(obj)}</div>
                      </div>
                    }
                  </div>
                })
                : <div
                  className="no-data-msg">{language ? this.renderSwitch(language) : 'Could`t render data'}</div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withFirebase(withModal(ContentComponent));
